import React, { useState } from 'react';
import Breadcrumbs from '../../Common/Breadcrumbs';
import WeeklyReportForm from './components/WeeklyReportForm';
import { useLocation, useNavigate } from 'react-router-dom';

const WeeklyReportDetailPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // Determine if editing or creating based on location state or URL (adjust as needed)
  const isEdit = location.state && (location.state.isEdit || location.state.edit || location.state.report);
  // Set initial reportTitle from state or report object
  const [reportTitle, setReportTitle] = useState(location.state?.title || location.state?.report?.title || '');

  return (
    <div className="container-fluid" style={{ marginTop: '20px' }}>
      <Breadcrumbs
        items={[
          { label: 'Weekly Reports Management', onClick: () => navigate('/WeeklyReports') },
          { label: isEdit ? (reportTitle || 'Edit Weekly Report') : 'Create New Weekly Report', active: true }
        ]}
      />
      <WeeklyReportForm
        isEdit={isEdit}
        reportTitle={reportTitle}
        onTitleChange={setReportTitle}
      />
    </div>
  );
};

export default WeeklyReportDetailPage; 